import React from "react";
import { FaTwitch } from "react-icons/fa";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(FaTwitch).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const TwitchIcon = (props) => {
  return <StyledIcon {...props} />;
};

TwitchIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default TwitchIcon;
